import React from 'react';

import { cx } from '@emotion/css';
import { Category, Post, Tag } from '@lib/wordpress.d';

import styles from './BlogDetails.module.scss';
import { BlogRight } from './BlogRight';
import { FAQsConnector } from './FAQsConnector';
import { Hero } from './Hero';
import { LeftMenu } from './LeftMenu';
// import { ReadMore } from './ReadMore';
// import { CardList } from '../list/CardList';
import { RelatedBlogs } from '../relatedBlogs/relatedBogs';

type Props = {
  post: Post;
  postTags: Tag[];
  categories: Category[];
  allTags: Tag[];
};
export const BlogDetails = (props: Props) => {
  const { post, postTags, categories, allTags } = props;

  return (
    <div className={cx(styles.blog_wraper, styles.blog_detail_wraper)}>
      <Hero post={post} styles={styles} />
      <section className={styles.blog_details}>
        <div className={cx(styles.container, styles.root)}>
          <div className={styles.blog_details_row}>
            <LeftMenu post={post} styles={styles} />
            <BlogRight
              post={post}
              styles={styles}
              tags={postTags}
              categories={categories}
            />
          </div>
          <h4 className={cx(styles.read_title, styles.h4)}>Related Articles</h4>

          <div className={styles.blogs_wrap}>
            <div className={cx(styles.container, styles.blogs_wrap_container)}>
              <RelatedBlogs
                styles={styles}
                categoryId={post.categories[0]}
                categories={categories}
                allTags={allTags}
              />
            </div>
          </div>
        </div>
      </section>
      <FAQsConnector post={post} />
    </div>
  );
};
